import * as React from 'react';
import { DirectoryStoreState } from '../../types';
import { getFilteredStores } from '../../reducers/stores';
import { useMappedState } from 'redux-react-hook';
import { StoreItem } from '../StoreItem';
import { useCallback } from 'react';
import { NoResults } from './NoResults';

export interface StoreItemProps {}

export const StoresList: React.FC<StoreItemProps> = () => {
  const { storesCount } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        storesCount: getFilteredStores(state).length,
      }),
      []
    )
  );

  return (
    <div>
      <h2 className="title">Stores</h2>
      {storesCount ? (
        new Array(storesCount).fill(null).map((_, index) => <StoreItem index={index} key={index} />)
      ) : (
        <NoResults />
      )}
    </div>
  );
};
